import { render, staticRenderFns } from "./caixa.vue?vue&type=template&id=edb33caa&"
import script from "./caixa.vue?vue&type=script&lang=js&"
export * from "./caixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports